import { updateBook } from "../actions";

const updateSingleBook = (data) => {

    return async (dispatch) => {
        const response = await fetch(`http://localhost:9000/books/${data.id}`, {
            method: "PATCH",
            body: JSON.stringify({
                ...data
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
        });
        const updatedBook = await response.json();

        dispatch(updateBook(updatedBook));
    }
}
export default updateSingleBook;